import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import Device from '../../../devices/device';
import Utils from '../../../utils/Utils';

import {PLY_PLY_00009,PLY_PLY_00001, APIVERSION} from '../../../AAFPlayer/constants';
// Sending info to the dashboard
import TrackerManager from '../../../utils/TrackerManager';
import EventEmitter from '../../../utils/EventEmitter';
import { AAF_CONTENT_IS_VOD } from "../../../AAFPlayer/constants";
class PlayerGetMediaTask extends AbstractRequestTask {
  constructor(groupId = "", contentId = "", isTrailer = false, stream_type = "", startTime = "", endTime = "", payway_token = "", showErrorModal, extraParamsEmitter = null) {
    super();
    console.log('Veamos media1 ', groupId, payway_token);

    const device_config = Device.getDevice().getConfig();
    this.player = Device.getDevice().getPlayer();
    this.groupId = groupId;
    this.contentId = contentId;
    this.isTrailer = isTrailer;
    this.stream_type = stream_type ? stream_type : device_config && device_config.stream_type ? device_config.stream_type : 'smooth_streaming';
    this.startTime = startTime ? Utils.getClaroUnixEpochTime(startTime) : '';
    this.endTime = endTime ? Utils.getClaroUnixEpochTime(endTime) : '';
    this.payway_token = payway_token ? payway_token : false;
    this.showErrorModal = showErrorModal;
    this.extraParamsEmitter = extraParamsEmitter;
    this.streamContentType = (extraParamsEmitter && extraParamsEmitter.streamContentType) || null;
    this.provider = (extraParamsEmitter && extraParamsEmitter.provider) ? extraParamsEmitter.provider.toLowerCase() : null;
    this.isProviderHBO = this.streamContentType === AAF_CONTENT_IS_VOD && this.provider === 'hbov2';
    this.statusCode402As200 = this.isProviderHBO;
    this.statusCode404As200 = this.isProviderHBO;
    this.statusCode500As200 = this.isProviderHBO;
    this.statusCode501As200 = this.isProviderHBO;
    console.log('Veamos media2 ', groupId, this.payway_token);
  }

  getEncType() {
    if (this.getMethod() === 'POST') {
      return 'application/x-www-form-urlencoded';
    }
    else {
      return super.getEncType();
    }
  }

  getShowErrorModal(){
    return Utils.showModalError();
  }

  getRetriesNumber(){
    if (this.isProviderHBO) {
      return Utils.getRegionaliazedMetadata('retries_HBO', '{"default": 3,"mexico": 2}');
    }
    if(this.showErrorModal){
      return 2;
    }else{
      return 4;
    }
  }

  getShowModal() {
    if (this.getMethod() === 'POST') {
      return false;
    }
    else {
      return super.getShowModal();
    }
  }

  getUrl() {
    const params = super.getParams();
    const http = "https://";
    const url = Launcher.get("akamai_mfwk");
    if (this.getMethod() === 'POST') {
      let _url = '';
      if(params.user_token) {
        _url = `${http}${url}/services/player/v1/getmedia?`
      } else {
        _url = `${http}${url}/services/player/getmedia?`
      }
      // let _url = `${http}${url}/services/player/v1/getmedia?`;
      _url += Utils.buildQueryParams(this.getGETParams());
      return _url;
    }
    else {
      if (this.isProviderHBO) return `${http}${url}/services/player/v3/getmedia`;
      return `${http}${url}/services/player/v1/getmedia`;
    }
  }

  getMethod() {
    if (Utils.adsIsEnabled() || this.isProviderHBO) {
      return 'GET';
    } else {
      return 'POST';
    }
  }

  getParams() {
    const paramsSuper = super.getParams();
    if (this.getMethod() === 'POST') {

      const params = {};
      params.api_version = APIVERSION;

      if(paramsSuper.user_token) {
        params.user_token = paramsSuper.user_token;
        delete params.api_version;
      }
      if (this.payway_token) {
        params.payway_token = this.payway_token;
      }


      return params;
    }
    else {
      return  this.getGETParams();
    }
  }

  getGETParams() {
    const params = super.getParams();
    params.api_version = APIVERSION;
    if (params.user_token) {
      delete params.HKS;
      delete params.api_version;
    }
    if (this.getMethod() === 'POST') {
      delete params.user_token;
    }
    const paramsMedia =  {
        group_id: this.groupId,
        content_id: this.contentId,
        stream_type: this.stream_type,
        preview: this.isTrailer ? "1" : "0",
        startTime: this.startTime,
        endTime: this.endTime,
        ...params
    };

    if (Utils.adsIsEnabled() || this.isProviderHBO) {
      paramsMedia["payway_token"] = this.payway_token;
    }

    return paramsMedia;
  }

  success(data, b) {
    this.resolve(data);
  }

  isValid(data) {
    if(data.errors && data.errors[0] && data.errors[0].code){
      if(data.errors[0].code!= PLY_PLY_00009 && data.errors[0].code!= PLY_PLY_00001 ){
        data.url=this.getUrl();
        TrackerManager.playerGetMedia(data);
      }
    }
    else {
      data.outputParams = this.extraParamsEmitter;
      EventEmitter.emit('player:setupTracker', { isVideo: true, data });
    }
    // devuelve false si requiere refresh de token desde el RequestManager
    if(data.errors && data.errors[0] && data.errors[0].code && data.errors[0].code === "USR_JWT_00002"){
      return false;
    }

    if(this.isProviderHBO && data && data.errors) return false;

    return true;
  }

  isHBO(data) {
    if (data.response &&
      data.response.group &&
      data.response.group.common &&
      data.response.group.common.extendedcommon &&
      data.response.group.common.extendedcommon.media &&
      data.response.group.common.extendedcommon.media.proveedor &&
      data.response.group.common.extendedcommon.media.proveedor.nombre) {
      return data.response.group.common.extendedcommon.media.proveedor.nombre === 'HBO';
    }
    return false;
  }

  isFOXV3(data) {
    if (data.response &&
      data.response.group &&
      data.response.group.common &&
      data.response.group.common.extendedcommon &&
      data.response.group.common.extendedcommon.media &&
      data.response.group.common.extendedcommon.media.proveedor &&
      data.response.group.common.extendedcommon.media.proveedor.codigo) {
      return data.response.group.common.extendedcommon.media.proveedor.codigo === 'foxv3';
    }
    return false;

  }

  getHeaders() {
    if (!this.method === 'POST') {
      return {
        'Access-Control-Allow-Origin': '*'
      };
    }
    else {
      return {
        'Content-Type': 'application/x-www-form-urlencoded'
      };
    }
  }
}

export default PlayerGetMediaTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/player/PlayerGetMediaTask.js